export const exemptedMessages = [
    "Payment needs to be made to access library content.",
    'This action is unauthorized.',
    'You are not authorized to access library content.'
]